import InvoicePaymentForm from './InvoicePaymentForm/index';

export default InvoicePaymentForm;